import * as Sentry from '@sentry/browser';
import './plugins/organization';
import * as dateFNS from 'date-fns';

if (process.env.NODE_ENV !== 'development' && process.env.MIX_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.MIX_SENTRY_DSN,
  });
}

window._ = require('lodash');

window.Sentry = Sentry;

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

global.jQuery = require('jquery');

global.$ = global.jQuery;

require('bootstrap-sass');

require('./plugins/ajax');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.dateFNS = dateFNS;

window.axios.defaults.headers.common = {
  'X-CSRF-TOKEN': window.Laravel.csrfToken,
  'X-Requested-With': 'XMLHttpRequest',
};

/**
 * SweetAlert 2
 */
window.swal = require('sweetalert2');
